'use client'

import Breadcrumb from '@component/breadcrumb'
import DisablePrefetchLink from '@component/disablePrefetchLink'
import getEstimateRoute from '@plugin/searchRoute/modules/estimate'
import getHouseRoute from '@plugin/searchRoute/modules/house'
import { estimateMap, houseList } from '@router'
import { getHouseTypeData, joinStr } from '@utils'
import { isEstimateData, isLandHomeData, isNewhomeData, isProjectData, isRuralForSaleData, isVillageData } from '@utils/house'

export default function HouseBreadcrumb({
  data
}) {
  const isVillage = isVillageData(data)
  return (
    <div className='page-wrap'>
      <Breadcrumb back text={data.street}>
        <TypeLink data={data}></TypeLink>
        {data.region && <RegionLink data={data}></RegionLink>}
        {data.district && <DistrictLink data={data}></DistrictLink>}
        {!isVillage && data.suburb && <SuburbLink data={data}></SuburbLink>}
      </Breadcrumb>
    </div>
  )
}

function TypeLink({
  data
}) {
  let { type, text } = getHouseTypeData(data)
  if (isRuralForSaleData(data)) {
    text = 'Rural for sale'
  }

  let href
  if (isEstimateData(data)) {
    const estimateRoute = getEstimateRoute()
    estimateRoute.pushNewZealand()
    href = estimateMap(estimateRoute.toSlug())
  } else {
    const houseRoute = getHouseRoute()
    houseRoute.pushNewZealand()
    if (isProjectData(data) || isNewhomeData(data)) {
      houseRoute.isLandHome = isLandHomeData(data) ? 1 : 0
    }

    href = houseList(type, houseRoute.toSlug())
  }

  return (
    <DisablePrefetchLink href={href} prefetch={false}>{text}</DisablePrefetchLink>
  )
}

function RegionLink({
  data
}) {
  if (!data.regionId) return

  let href
  if (isEstimateData(data)) {
    const estimateRoute = getEstimateRoute()
    estimateRoute.setSuburbs({ label: data.region, id: data.regionId, level: 'region' })
    href = estimateMap(estimateRoute.toSlug())
  } else {
    const houseRoute = getHouseRoute()
    houseRoute.setSuburbs({ label: data.region, id: data.regionId, level: 'region' })
    if (isProjectData(data) || isNewhomeData(data)) {
      houseRoute.isLandHome = isLandHomeData(data) ? 1 : 0
    }
    const { type } = getHouseTypeData(data)
    href = houseList(type, houseRoute.toSlug())
  }

  return (
    <DisablePrefetchLink href={href} prefetch={false}>{data.region}</DisablePrefetchLink>
  )
}

function DistrictLink({
  data
}) {
  if (!data.districtId) return

  let href
  if (isEstimateData(data)) {
    const estimateRoute = getEstimateRoute()
    estimateRoute.setSuburbs({ label: joinStr([data.district, data.region], ', '), id: data.districtId, level: 'district' })
    href = estimateMap(estimateRoute.toSlug())
  } else {
    const houseRoute = getHouseRoute()

    houseRoute.setSuburbs({ label: joinStr([data.district, data.region], ', '), id: data.districtId, level: 'district' })
    if (isProjectData(data) || isNewhomeData(data)) {
      houseRoute.isLandHome = isLandHomeData(data) ? 1 : 0
    }

    const { type } = getHouseTypeData(data)
    href = houseList(type, houseRoute.toSlug())
  }

  return (
    <DisablePrefetchLink href={href} prefetch={false}>{data.district}</DisablePrefetchLink>
  )
}

function SuburbLink({
  data
}) {
  if (!data.suburbId) return

  let href
  if (isEstimateData(data)) {
    const estimateRoute = getEstimateRoute()
    estimateRoute.setSuburbs({ label: joinStr([data.suburb, data.district], ', '), id: data.suburbId, level: 'suburb' })
    href = estimateMap(estimateRoute.toSlug())
  } else {
    const houseRoute = getHouseRoute()
    houseRoute.setSuburbs({ label: joinStr([data.suburb, data.district], ', '), id: data.suburbId, level: 'suburb' })
    if (isProjectData(data) || isNewhomeData(data)) {
      houseRoute.isLandHome = isLandHomeData(data) ? 1 : 0
    }

    const { type } = getHouseTypeData(data)
    href = houseList(type, houseRoute.toSlug())
  }

  return (
    <DisablePrefetchLink href={href} prefetch={false}>{data.suburb}</DisablePrefetchLink>
  )
}
